import { TeButtonOutline, TeContainer, TeContainerSlim, TeIcon, TeText } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';

import { IdentityBody } from '../../api/generated/pap';
import { IconWrapper } from '../../utils/styling';

interface Props {
  identity: IdentityBody;
  onSupport: (identity: IdentityBody) => void;
}

function TopconIdUser({ identity, onSupport }: Props) {
  const { t } = useTranslation('topconId');

  return (
    <TeContainer
      backgroundColor="background.primary"
      borderColor="border.secondary"
      borderRadius="m"
      padding={['s', 'm']}
      fill
      height="84"
    >
      <IconWrapper>
        <TeIcon size="l" name="person" />
      </IconWrapper>
      <TeContainerSlim column grow overflow="hidden" justifyContent="space-between">
        <TeText weight="medium" truncate>
          {identity.firstName} {identity.lastName}
        </TeText>
        <TeText size="s" color="text.secondary" truncate>
          {identity.email}
        </TeText>
      </TeContainerSlim>
      <TeContainerSlim fill alignItems="center">
        <TeButtonOutline
          text={t('supportButton')}
          teclick={() => onSupport(identity)}
          testId={`support-identity-${identity.id}`}
        />
      </TeContainerSlim>
    </TeContainer>
  );
}

export default TopconIdUser;
